<template>
	<div class="fixed bottom-0 w-full layout">
		<!-- menu -->
		<div class="flex bg-whiteBase p-4 text-sm">
			<div class="flex-1">
				<div class="flex text-navyBlue flex-col float-left">
					<router-link to="/" exact>
						<fai
							v-if="Home"
							:icon="['fas', 'th-large']"
							class=" text-lightPurple"
							size="lg"
						/>
						<fai
							v-else
							:icon="['fas', 'th-large']"
							class=" text-navyBlue"
							size="lg"
						/>
						<p>Beranda</p>
					</router-link>
				</div>
			</div>
			<div class="flex-1">
				<div class="flex text-navyBlue flex-col">
					<router-link to="/comission" exact>
						<fai
							v-if="Comission"
							:icon="['fas', 'coins']"
							class=" text-lightPurple"
							size="lg"
						/>
						<fai
							v-else
							:icon="['fas', 'coins']"
							class=" text-navyBlue"
							size="lg"
						/>
						<p>Komisi</p>
					</router-link>
				</div>
			</div>
			<div class="flex-1">
				<div class="flex text-navyBlue flex-col -mt-9 ">
					<div class="">
						<img
							class="w-min mx-auto add"
							src="../../../assets/dashboard/home/add.svg"
							alt="add"
							srcset=""
						/>
					</div>
				</div>
			</div>
			<div class="flex-1">
				<div class="flex text-navyBlue flex-col">
					<router-link to="/transaction" exact>
						<fai
							v-if="Transaction"
							:icon="['fas', 'clipboard-list']"
							class=" text-lightPurple"
							size="lg"
						/>
						<fai
							v-else
							:icon="['fas', 'clipboard-list']"
							class=" text-navyBlue"
							size="lg"
						/>
						<p>Transaksi</p>
					</router-link>
				</div>
			</div>
			<div class="flex-1">
				<div class="flex text-navyBlue flex-col float-right">
					<router-link to="/settings" exact>
						<fai
							v-if="Settings"
							:icon="['fas', 'cog']"
							class=" text-lightPurple"
							size="lg"
						/>
						<fai
							v-else
							:icon="['fas', 'cog']"
							class=" text-navyBlue"
							size="lg"
						/>
						<p>Pengaturan</p>
					</router-link>
				</div>
			</div>
		</div>
		<!-- end menu -->
	</div>
</template>

<script>
export default {
	name: "Menus",
	data() {
		return {
			Home: false,
			Comission: false,
			Transaction: false,
			Settings: false,
			ColourLightPurple: "#7551E9",
			ColourNavyBlue: "#16213E",
		};
	},
	components: {},
	created: function() {
		//Set Active Menus
		this.Home = false;
		this.Comission = false;
		this.Transaction = false;
		this.Settings = false;
		if (this.$route.name == "home") {
			this.Home = true;
		}
		if (this.$route.name == "comission") {
			this.Comission = true;
		}
		if (this.$route.name == "transaction") {
			this.Transaction = true;
		}
		if (this.$route.name == "settings") {
			this.Settings = true;
		}
	},
};
</script>

<style scoped>
.add {
	max-width: 100%;
	height: auto;
	border-bottom-width: 3px;
	border-radius: 100%;
	border-color: #f9f9f9;
}
.router-link-active {
	color: #7551e9;
}
</style>
